import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getFormData } from '../../../selectors/formSelector';
import Product from './product';
import { actions } from 'react-redux-form';

class ProductSelection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
    };
  }

  /**
   * Sets ProductSelection variable to product parameter.  Generally this result is passed to a branch node.
   * Then calls parent handleNext() function.
   * @param product
   */
  chooseBranch(product) {
    this.props.dispatch(actions.change(`formData.ProductSelection`, product));
    this.props.handleNext();
  }

  /**
   * Sets ProductSelection variable to unlock constant.  Generally this result is passed to a branch node.
   * Then calls parent handleNext() function.
   */
  unlockLenders() {
    this.props.dispatch(actions.change(`formData.ProductSelection`, 'unlock'));
    this.props.handleNext();
  }

  /**
   * Orders product selection based on product ask
   * @param {string[]} products
   * @returns {string[]}
   */
  orderSelectedProducts(products) {
    const orderedProducts = [];

    if (products.indexOf('refinance') >= 0) {
      orderedProducts.push('refinance');
    }

    if (products.indexOf('auto') >= 0) {
      orderedProducts.push('auto');
    }

    if (products.indexOf('slrefi') >= 0) {
      orderedProducts.push('slrefi');
    }

    if (products.indexOf('personal') >= 0) {
      orderedProducts.push('personal');
    }

    return orderedProducts;
  }

  /**
   * Render product selection nodes
   */
  render() {
    // An array of products to render
    const products = [];

    // Array of selected products, ordered based Product requirements
    const orderedProducts = this.orderSelectedProducts(
      this.props.step.selectedproducts
    );

    // Loop through all configured products
    for (let product of orderedProducts) {
      // Get user readable label
      const label = this.props.step.productLabels[product];

      // Show "start product flow" node for each product
      products.push(
        <Product
          key={product}
          label={label}
          product={product}
          handleNext={this.chooseBranch.bind(this)}
          completedResult={{}}
        />
      );
    }

    return (
      <div className="ltFormContainer">
        <div className="ltFormHeader">
          Where do you want to start looking for savings?
        </div>
        <main>{products}</main>
      </div>
    );
  }
}

ProductSelection.propTypes = {
  // Platform props
  step: PropTypes.object,
  dispatch: PropTypes.func,
  formData: PropTypes.object,
  handleNext: PropTypes.func,

  // Builder props
  selectedproducts: PropTypes.array,
  productLabels: PropTypes.object,

  // Product Selection props
};

// Here be dragons
function mapStateToProps(state) {
  return {
    formData: getFormData(state),
  };
}

export default connect(mapStateToProps)(ProductSelection);
